import { createContext, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  GlobalFeatureNameSpaceNotary,
  CommonActionSubTypeNotary
} from './globalNotary'

const SliceContext = createContext({})

const SliceProvider = ({ slice, children }) => (
  <SliceContext.Provider value={slice}>{children}</SliceContext.Provider>
)

const useSliceActions = () => useContext(SliceContext).actions

const useSliceSelector = () => {
  const { name } = useContext(SliceContext)
  return useSelector(state => {
    return state[name]
  })
}

export default SliceProvider

export {
  useDispatch,
  useSelector,
  useSliceActions,
  useSliceSelector,
  GlobalFeatureNameSpaceNotary,
  CommonActionSubTypeNotary
}
